import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';

@Component({
  selector: 'app-email-notifications',
  templateUrl: './email-notifications.component.html',
  styleUrls: ['./email-notifications.component.scss'],
})
export class EmailNotificationsComponent {
  @Input() entity: any;
  @Output() setNewEntity = new EventEmitter<any>();

  notificationFlags = [
    {
      key: 'takeSurveyNotificationFlag',
      label: 'Take Survey Notification',
      description: 'Send notifications to users to take surveys',
    },
    {
      key: 'honorValidationNotificationFlag',
      label: 'Honor Validation Notification',
      description: 'Send notifications for honor validation',
    },
    {
      key: 'weekGlanceNotificationFlag',
      label: 'Week Glance Notification',
      description: 'Send weekly glance notifications',
    },
    {
      key: 'groupPushNotificationFlag',
      label: 'Group Push Notification',
      description: 'Send notifications for group pushes',
    },
    {
      key: 'courseRequestDecisionNotificationFlag',
      label: 'Course Request Decision Notification',
      description: 'Send notifications for course request decisions',
    },
    {
      key: 'selfRegNotificationFlag',
      label: 'Self Registration Notification',
      description: 'Send notifications for self-registration',
    },
    {
      key: 'courseStatusUpdateNotificationFlag',
      label: 'Course Status Update Notification',
      description: 'Send notifications when courses are cancelled or restored',
    },
  ];

  onToggleChange(flagKey: string, value: boolean): void {
    const updatedEntity = {
      ...this.entity,
      Config: {
        ...this.entity.Config,
        [flagKey]: value ? 1 : 0,
      },
    };

    this.setNewEntity.emit(updatedEntity);
  }

  getNotificationValue(flagKey: string): boolean {
    return this.entity?.Config?.[flagKey] === 1;
  }
}
